module.exports = __webpack_public_path__ + "assets/img/pdf_ico.cad8c831.png";